import { Box, Collapse, Container, Fade, Grid, Slide } from '@material-ui/core';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import { SetStateAction } from 'react';
import { useAppSelector } from '../reduxhooks';
import { SYSTEM_ALL_HANDLE } from '../terbebasApi';

import MobileCategoryMenuItem from './MobileCategoryMenuItem';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    menuWindow: {
      display: 'block',
      position: 'fixed',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      background: '#fafafa',
      zIndex: 2,
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
  }),
);

interface MobileCategoryMenuProps {
  navState: string,
}

function MobileCategoryMenu({ navState }: MobileCategoryMenuProps) {
  const classes = useStyles();

  // Store-defined Kategori pages (ordered), replacing the legacy static list.
  const categoriesDictionary = useAppSelector(state => state.productsList.categoriesDictionary) ?? {};
  const categoriesOrder = useAppSelector(state => state.productsList.categoriesOrder) ?? [];

  return (
    <Slide in={navState === "MENU"}>
      <Box className={classes.menuWindow}>
        <Toolbar/>
        <MobileCategoryMenuItem
          navState={navState}
          title={"SEMUA PRODUK"}
          // /shop resolves through the system Kategori, so it renders the same
          // page as /shop/category/semua-produk — link the canonical URL.
          routeLink={"/shop"}
          eventName={"categoryMenuAll"} />
        {
          categoriesOrder.map((handle) => {
            const category = categoriesDictionary[handle];
            if (!category || handle === SYSTEM_ALL_HANDLE) return null;
            return <MobileCategoryMenuItem
              key={handle}
              navState={navState}
              title={category.title.toUpperCase()}
              routeLink={"/shop/category/" + handle}
              eventName={"categoryMenu-" + handle} />;
          })
        }
      </Box>
    </Slide>
  );
}

export default MobileCategoryMenu;